import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { parse } from 'query-string';
import { withLocalization } from '@shared-ui/localization-context';
import { useLodgingURLParamsToQueryInputs } from '@shared-ui/retail-search-tools-lodging';
import { SortAndFiltersViewType } from '@shared-ui/retail-sort-and-filter-lodging';
import { getPropertySearchInputWithSearchId } from 'stores/adapters';
import { MapPreview } from 'components/search/map/map-preview';
import { UniversalSortFilterWrapper } from './sort-filter/universal-sort-filter';
const SidebarComponent = inject('context', 'searchCriteria', 'searchResults', 'multiItem', 'analyticsSearch')(({
  l10n,
  context,
  searchResults,
  tracker,
  viewTracker,
  location,
  multiItem,
  searchCriteria,
  bexQuickFiltersEnabled,
  analyticsSearch
}) => {
  var _a, _b;
  const lodgingQueryInputs = useLodgingURLParamsToQueryInputs();
  if (!context || !searchResults || !searchCriteria || !analyticsSearch) return null;
  const searchResultsCriteria = searchResults.searchCriteria;
  const regionId = searchResultsCriteria === null || searchResultsCriteria === void 0 ? void 0 : searchResultsCriteria.regionId;
  const destination = searchResultsCriteria === null || searchResultsCriteria === void 0 ? void 0 : searchResultsCriteria.destination;
  const latLong = searchResultsCriteria === null || searchResultsCriteria === void 0 ? void 0 : searchResultsCriteria.latLong;
  const group = searchResultsCriteria === null || searchResultsCriteria === void 0 ? void 0 : searchResultsCriteria.group;
  const formatText = l10n === null || l10n === void 0 ? void 0 : l10n.formatText;
  const pwaMapOverlay = Boolean(parse(location.search).pwaOverlay === 'map');
  // Fallback Google typeahead may not resolve any meaningful criteria, but we need to show the bar anyway
  const isDestinationOnly = !regionId && !latLong && !group && destination;
  const shouldShowSidebar = isDestinationOnly || regionId || latLong || group;
  // TODO: reuse getSharedUIListingInputsWithSearchId if possible -- multiItem store will be needed as an optional param
  const inputs = getPropertySearchInputWithSearchId(context, analyticsSearch, searchCriteria, multiItem === null || multiItem === void 0 ? void 0 : multiItem.multiItemContext);
  const rooms = (_a = lodgingQueryInputs === null || lodgingQueryInputs === void 0 ? void 0 : lodgingQueryInputs.propertySearchCriteriaInput) === null || _a === void 0 ? void 0 : _a.primary.rooms;
  if (((_b = inputs === null || inputs === void 0 ? void 0 : inputs.criteria) === null || _b === void 0 ? void 0 : _b.primary) && rooms) {
    inputs.criteria.primary.rooms = rooms;
  }
  const content = React.createElement(React.Fragment, null, React.createElement(MapPreview, {
    viewTracker: viewTracker,
    tracker: tracker,
    searchInputs: inputs,
    bexQuickFiltersEnabled: bexQuickFiltersEnabled
  }), shouldShowSidebar && !bexQuickFiltersEnabled && React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "is-visually-hidden"
  }, formatText && formatText('hotels.searchResults.filtersDialog.title')), !pwaMapOverlay && React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'twelve'
    }
  }, React.createElement(UniversalSortFilterWrapper, {
    view: SortAndFiltersViewType.FILTERS
  }))));
  return bexQuickFiltersEnabled ? content : React.createElement("section", {
    "data-stid": "desktop-sidebar"
  }, content);
});
export const Sidebar = withLocalization(withRouter(SidebarComponent));